// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/eraser.js';

import { paths } from '../generated/eraser';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('eraser', Original, paths);
